import styled from "@emotion/styled";
import {
  AllCaps,
  Container,
  FlexRow,
  IconDiscord,
  IconInstagram,
  IconOpenSea,
  IconTwitter,
  Link,
  Text,
} from "atoms";
import { constants } from "config";
import { Newsletter } from "./Newsletter";

function SiteFooter() {
  return (
    <Footer>
      <Container width="sm">
        <Newsletter />
      </Container>
      <FooterMain>
        <Container width="sm">
          <SFlexRow as="nav" justifyContent="center">
            <SocialLink
              href={constants.twitterURL}
              aria-label="Hug on Twitter"
              target="_blank"
            >
              <IconTwitter
                primary="black"
                accent="accent1"
                aria-hidden="true"
                focusable="false"
              />
            </SocialLink>

            <SocialLink
              href={constants.instagramURL}
              aria-label="Hug on Instagram"
              target="_blank"
            >
              <IconInstagram
                primary="black"
                accent="accent4"
                aria-hidden="true"
                focusable="false"
              />
            </SocialLink>

            <SocialLink
              href={constants.openseaURL}
              aria-label="Hug on OpenSea"
              target="_blank"
            >
              <IconOpenSea
                primary="black"
                accent="accent3"
                aria-hidden="true"
                focusable="false"
              />
            </SocialLink>

            <SocialLink
              href={constants.discordURL}
              aria-label="Join Hug on Discord"
              target="_blank"
            >
              <IconDiscord
                primary="black"
                accent="accent2"
                aria-hidden="true"
                focusable="false"
              />
            </SocialLink>
          </SFlexRow>

          <TermsText size="xxs">
            <Link to="/about">About Us</Link>
            {" | "}
            <Link to="/support">Get Support</Link>
            {" | "}
            <Link to="/privacy-policy">Privacy Policy</Link>
            {" | "}
            <Link to="/terms-of-service">Terms of Service</Link>
          </TermsText>

          <TermsText size="xxs">
            <br />
            Some of the projects listed are clients of <AllCaps>
              Hug
            </AllCaps>{" "}
            Studios, our advisory program which provides strategic guidance and
            mentorship to&nbsp;businesses.
          </TermsText>
          <TermsText size="xxs">
            Copyright &copy; Assemble Stream, Inc. All rights reserved.
          </TermsText>
        </Container>
      </FooterMain>
    </Footer>
  );
}

const Footer = styled.footer(({ theme }) => ({
  backgroundColor: theme.colors.black,
  paddingBottom: "env(safe-area-inset-bottom)",
}));
const FooterMain = styled.div(({ theme }) => ({
  color: theme.colors.white80,
  a: {
    color: theme.colors.white,
    "&:hover, &:focus-visible": {
      color: theme.colors.white80,
    },
  },
  padding: `${theme.spacing.xl} 0 ${theme.spacing.lg}`,
}));

const SFlexRow = styled(FlexRow)({
  margin: "1.5rem 0",
});
const SocialLink = styled(Link)(({ theme }) => ({
  ...theme.fonts.body,
  alignItems: "center",
  backgroundColor: theme.colors.white,
  borderRadius: theme.borderRadius.round,
  boxShadow: `0 0 0 0 ${theme.colors.white}`,
  display: "flex",
  fontSize: 24,
  height: 40,
  justifyContent: "center",
  width: 40,
  position: "relative",
  overflow: "hidden",
  transition: ".2s ease box-shadow",
  svg: {
    pointerEvents: "none",
    position: "relative",
    zIndex: 2,
  },
  "&:hover, &:focus-visible": {
    borderColor: theme.colors.white,
    boxShadow: `0 0 0 2px ${theme.colors.white}`,
  },
}));

const TermsText = styled(Text)(({ theme }) => ({
  paddingBottom: ".5rem",
  textAlign: "center",
  maxWidth: "600px",
  marginLeft: "auto",
  marginRight: "auto",
  display: "block",
  a: {
    whiteSpace: "nowrap",
  },
}));

export { SiteFooter };
